import { render } from "./AppInputText.vue?vue&type=template&id=07b9eefe"
import script from "./AppInputText.vue?vue&type=script&lang=ts"
export * from "./AppInputText.vue?vue&type=script&lang=ts"
script.render = render

export default script